var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"log-link"},[(_vm.isImageLink)?[_c('a',{staticClass:"image-link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.url}})])]:[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.link))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }